import React from 'react';
import { LabelProps, Label } from '@kizi/core-components';
import { withTooltip, IconV2 } from '@kizi/shared-components';

const TooltipIcon = withTooltip(IconV2);

export interface ComparisonLabelProps extends LabelProps {
  label: string;
  tooltip?: string;
  variant?: string;
}

export const ComparisonLabel: React.FC<ComparisonLabelProps> = ({
  label,
  tooltip,
  variant = 'footnoteRegular',
  ...restProps
}) => {
  return (
    <Label display="flex" variant={variant} {...restProps}>
      {label}
      {tooltip && (
        <TooltipIcon
          ml={1}
          position="relative"
          bottom="1px"
          name="info"
          size={18}
          css={{ fill: 'main.1' }}
          _tooltip={tooltip}
          cursor="pointer"
        />
      )}
    </Label>
  );
};
